import React from 'react';
import {GenericSettingsModal} from 'components/modals';
import DictionarySettingsForm from './DictionarySettingsForm';
import i18n from 'i18n';

interface DictionarySettingsModalProps {
    modalOpen: boolean;
    closeModal: () => void;
    activeDictionaryId: number;
}

const DictionarySettingsModal: React.FC<DictionarySettingsModalProps> = React.memo((
    {
        modalOpen,
        closeModal,
        activeDictionaryId,
    },
) => (
    <GenericSettingsModal
        isOpen={modalOpen}
        onClose={closeModal}
        title={i18n.t('jt_lexicon_settings.text')}
        entityId={activeDictionaryId}
        entityIdPropName="dictionaryId"
        FormComponent={DictionarySettingsForm}
    />
));

export default DictionarySettingsModal; 